export default "__VITE_ASSET__BBHY2cG8__";